import {
  FIELD_SETTING_OBJECTS,
  FIELD_SETTING_PATH,
} from 'hb-builder/components/BuilderComponents/dynamic/EmailPublication/PublicationSettings/constants/fieldSettingsObjects';
import type {
  EmailPublicationItemAttributes,
  EmailPublicationType,
} from 'hb-builder/components/BuilderComponents/dynamic/EmailPublication/types';
import { DisplayFieldOptionInFieldList } from 'hb-builder/components/common/SettingsLibrary/CommonSettings/DisplayFieldOption';
import AccordionTitle from 'hb-builder/components/common/SettingsLibrary/SettingsDecoration/AccordionTitle';
import type { ComponentSettingsTab } from 'hb-builder/types/settings';

const findFieldSetting = (field, contentType) =>
  FIELD_SETTING_OBJECTS[contentType]?.filter(
    (fieldSetting) => fieldSetting.identifier === field,
  )?.[0];

type FieldsDrawerProps = Pick<
  ComponentSettingsTab<EmailPublicationItemAttributes>,
  'item' | 'onChange'
> & {
  contentType?: EmailPublicationType;
};

const FieldsDrawer = ({ contentType, item, onChange }: FieldsDrawerProps) => {
  const { dynamicAttributes } = item.attributes || {};
  const fieldsAttributes = dynamicAttributes
    ? Object.keys(dynamicAttributes.fields)
    : [];

  const renderFieldsSettings = (fieldsAttributes) =>
    fieldsAttributes.map((field, index) => {
      const fieldSetting = findFieldSetting(field, contentType);

      if (!fieldSetting) {
        return null;
      }

      return (
        <DisplayFieldOptionInFieldList
          fieldSetting={fieldSetting}
          fieldSettingPath={FIELD_SETTING_PATH}
          index={index}
          item={item}
          key={fieldSetting.identifier}
          onChange={onChange}
        />
      );
    });

  return (
    <AccordionTitle title={__('Fields')}>
      {renderFieldsSettings(fieldsAttributes)}
    </AccordionTitle>
  );
};

export default FieldsDrawer;
